// extracted by mini-css-extract-plugin
export default {"moreResultsButton":"Paginator_moreResultsButton__7JB+V"};